import {
  SET_REFUND_RECIPIENT_FORM_FIELD,
  SET_REFUND_RECIPIENT_FORM
} from 'actions/account/billing/actionTypes'

import setRefundRecipientForm from './setRefundRecipientForm'
import setRefundRecipientFormField from './setRefundRecipientFormField'

const reducer = (state = {}, action) => {
  switch (action.type) {
    case SET_REFUND_RECIPIENT_FORM_FIELD:
      return setRefundRecipientFormField(state, action)
    case SET_REFUND_RECIPIENT_FORM:
      return setRefundRecipientForm(state, action)
    default:
      return state
  }
}

export default reducer
